/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import 'react-phone-input-2/lib/style.css';
import FieldContainer from 'components/layout/FieldContainer';
import { Button } from 'tt-ui-lib/core';
import { WarningIcon } from 'tt-ui-lib/icons';
import { CONFIRMED_ITEMS } from 'constants/profilePage';
import LocationModal from 'core/views/JoinPage/SignUpPage/Modals/LocationModal';
import UserInfoReviewsItem from './UserInfoReviewsItem';
import UserInfoLocationItem from './UserInfoLocationItem';
import UserInfoItem from './UserInfoItem';
import UserInfoAvatar from './UserInfoAvatar';
import UserInfoMenu from './UserInfoMenu';
import UserInfoGeneralEditing from './UserInfoGeneralEditing';
import styles from './Userinfo.module.scss';
import { useSelectedContext } from 'context/contextSelector';

const LOCATION_MODAL_TITLE = 'TransparenTerra community map';
const FORM_ID = 'generalInfo';

export const UserInfo = ({
  userProps,
  isCurrentUser,
  changeIsLoading,
  selectUser,
  setUserProps,
}) => {
  const { user } = useSelectedContext((context) => context.user);
  const [address, setAddress] = useState(null);
  const [coordinates, setCoordinates] = useState(null);
  const [isEditingProfile, setIsEditingProfile] = useState(false);
  const [isLocationModal, setIsLocationModal] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    setAddress(null);

    if (userProps && userProps?.location) {
      setAddress(userProps?.location?.address);
      if (userProps?.location?.latLng) {
        setCoordinates({
          lat: parseFloat(userProps?.location?.latLng.lat),
          lng: parseFloat(userProps?.location?.latLng.lng),
        });
      }
    }
  }, [userProps]);

  const onModalClose = (setModal) => setModal(false);

  return (
    <FieldContainer
      title="General Information"
      className={styles.fieldWrapper}
      setIsEditingProfile={setIsEditingProfile}
      isEditingProfile={isEditingProfile}
      formId={FORM_ID}
      isLoading={isSaving}
    >
      {selectUser === 'blocked' && (
        <div className={styles.blocked}>
          <div className={styles.blockedMessage}>
            <WarningIcon className={styles.blockedIcon} style={{ width: 21, height: 18 }} />
            <p>This user is blocked</p>
          </div>
        </div>
      )}
      {isEditingProfile ? (
        <UserInfoGeneralEditing
          userProps={userProps}
          setIsEditing={setIsEditingProfile}
          changeIsLoading={changeIsLoading}
          setUserProps={setUserProps}
          setIsSaving={setIsSaving}
        />
      ) : isCurrentUser ? (
        <div className={styles.mainInformation}>
          <div className={styles.leftContent}>
            <UserInfoReviewsItem ranking={userProps?.ranking} reviews={userProps?.reviews} />
            {CONFIRMED_ITEMS.map((item) => (
              <UserInfoItem
                key={item.text}
                Icon={item.icon}
                iconWidth={item.iconWidth}
                iconHeight={item.iconHeight}
                text={item.text}
                isConfirmed={!!{}}
                userProps={userProps}
              />
            ))}
            <UserInfoLocationItem location={address} setIsLocationModal={setIsLocationModal} />
            <div className={styles.rightContent}>
              <button
                className={styles.editBtn}
                type="button"
                onClick={() => setIsEditingProfile((current) => !current)}
              >
                <img src="/images/admin/edit.svg" alt="" style={{ width: 24, height: 24 }} />
                EDIT
              </button>
            </div>
          </div>
          <UserInfoAvatar userProps={userProps} />
          <div className={styles.rightContent}>
            {userProps?.id && (
              <button
                className={styles.editBtn}
                type="button"
                onClick={() => setIsEditingProfile((current) => !current)}
              >
                <img src="/images/admin/edit.svg" alt="" style={{ width: 24, height: 24 }} />
                EDIT
              </button>
            )}
          </div>
          {user && user.id ? <UserInfoMenu isCurrentUser={isCurrentUser} /> : null}
        </div>
      ) : (
        <div className={styles.mainInformation}>
          <div className={styles.leftContent}>
            <UserInfoReviewsItem ranking={userProps?.ranking} reviews={userProps?.reviews} />
            {userProps &&
              CONFIRMED_ITEMS.map((item) => (
                <UserInfoItem
                  key={item.text}
                  Icon={item.icon}
                  iconWidth={item.iconWidth}
                  iconHeight={item.iconHeight}
                  text={item.text}
                  isConfirmed={!!{}}
                  userProps={userProps}
                />
              ))}
            {address && (
              <UserInfoLocationItem location={address} setIsLocationModal={setIsLocationModal} />
            )}
            <div className={styles.rightContent}>
              <div className={styles.buttonsWrapper}>
                {/* TODO Gregory message */}
                {userProps?.id !== 'c3c2c22e-2baf-41cc-afbb-1dc3f9d2d1f4' && (
                  <Link to={`/dashboard/messaging?profile=${userProps?.id}`}>
                    <Button style={{ minWidth: 125 }} disabled={selectUser === 'blocked'}>
                      MESSAGE
                    </Button>
                  </Link>
                )}
                <Button
                  /* onClick={send} */
                  style={{ minWidth: 125 }}
                  disabled={selectUser === 'blocked'}
                >
                  FOLLOW
                </Button>
                <Button
                  /* onClick={send} */
                  style={{ minWidth: 125 }}
                  disabled={selectUser === 'blocked'}
                >
                  CONNECT
                </Button>
              </div>
            </div>
          </div>

          <UserInfoAvatar userProps={userProps} />

          <div className={styles.rightContent}>
            <div className={styles.buttonsWrapper}>
              {/* TODO Gregory message */}
              {userProps?.id !== 'c3c2c22e-2baf-41cc-afbb-1dc3f9d2d1f4' && (
                <Link to={`/dashboard/messaging?profile=${userProps?.id}`}>
                  <Button style={{ minWidth: 125 }} disabled={selectUser === 'blocked'}>
                    MESSAGE
                  </Button>
                </Link>
              )}
              <Button
                /* onClick={send} */
                style={{ minWidth: 125 }}
                disabled={selectUser === 'blocked'}
              >
                FOLLOW
              </Button>
              <Button
                /* onClick={send} */
                style={{ minWidth: 125 }}
                disabled={selectUser === 'blocked'}
              >
                CONNECT
              </Button>
            </div>
          </div>
          <UserInfoMenu isCurrentUser={isCurrentUser} />
        </div>
      )}
      <LocationModal
        title={LOCATION_MODAL_TITLE}
        isModelOpen={isLocationModal}
        handleClose={onModalClose}
        setIsOpen={setIsLocationModal}
        address={address}
        coordinates={coordinates}
        isEditable={false}
        showSearch={false}
        zoom={18}
        background="#FFFFFF"
        isJoint
      />
    </FieldContainer>
  );
};
